import { SwapProvider } from './swap-provider.interface';
import { RouteQuote } from '../routing.service';
import { Web3Service } from '../web3.service';
import { QUOTER_V2_ABI } from '../../config/contracts.config';
import { ethers } from 'ethers';

export class DexorNativeProvider implements SwapProvider {
  constructor(private web3Service: Web3Service) { }

  async getQuote(tokenInAddress: string, tokenOutAddress: string, amount: bigint, isExactOut: boolean = false, feeTiers?: number[]): Promise<RouteQuote> {
    try {
      const contracts = this.web3Service.getContractsConfig();
      const quoter = await this.web3Service.getReadContract(contracts.QUOTER_V2, QUOTER_V2_ABI);

      const feesToTest = (feeTiers && feeTiers.length > 0) ? feeTiers : [500, 3000, 10000];
      let amountOut: bigint | null = null;
      let amountIn: bigint | null = null;
      let successfulFee = feesToTest[0] || 3000;
      let gasEstimate = 150000n;

      for (const fee of feesToTest) {
        try {
          if (isExactOut) {
            const params = {
              tokenIn: tokenInAddress,
              tokenOut: tokenOutAddress,
              amountOut: amount,
              fee: fee,
              sqrtPriceLimitX96: 0
            };
            const result = await quoter['quoteExactOutputSingle'].staticCall(params);
            amountIn = result.amountIn || result[0];
            amountOut = amount;
            gasEstimate = result.gasEstimate || result[3] || 150000n;
          } else {
            const params = {
              tokenIn: tokenInAddress,
              tokenOut: tokenOutAddress,
              amountIn: amount,
              fee: fee,
              sqrtPriceLimitX96: 0
            };
            const result = await quoter['quoteExactInputSingle'].staticCall(params);
            amountOut = result.amountOut || result[0];
            amountIn = amount;
            gasEstimate = result.gasEstimate || result[3] || 150000n;
          }
          successfulFee = fee;
          break; 
        } catch (e) {
          console.error(`Quoter Error for fee ${fee}:`, e);
        }
      }

      if (amountOut === null || amountIn === null) {
        throw new Error(`No liquidity found in native pool for these tokens across configured fee tiers: ${feesToTest.join(', ')}.`);
      }

      return {
        type: 'DEX',
        platformName: 'DEX Native Swap',
        targetAddress: contracts.SWAP_ROUTER,
        callData: successfulFee.toString(),
        value: '0',
        estimatedOutput: amountOut,
        estimatedInput: amountIn,
        gasEstimate: gasEstimate.toString()
      };
    } catch (err: any) {
      console.error('Failed to fetch from DEX Quoter:', err);
      throw new Error(`DEX Native Route Error: ` + err.message);
    }
  }
}
